import styles from './styles.pcss';
import tabViewFactory from '../tabViewFactory';

/**
 * TabsItem and TabsList use unified propTypes written in tabViewFactory
 */
export const [MenuTabsList, MenuTabsItem] = tabViewFactory(styles, 'MenuTab');
